import { InspectionFileValidator } from "./inspection-file.validator";

export async function extractFilesFromSystemEntries(entries: FileSystemEntry[], files: File[]): Promise<File[]> {
  for (const entry of entries) {
    if (entry.isDirectory) {
      const subEntries = await readDirectoryEntries(entry as FileSystemDirectoryEntry);
      await extractFilesFromSystemEntries(subEntries, files);
    } else {
      const file = await readFile(entry as FileSystemFileEntry);
      files.push(file);
    }
  }
  return files.filter(file => isUploadableFile(file.type, file.size, file.name));
}

async function readFile(fileEntry: FileSystemFileEntry): Promise<File> {
  return await new Promise<File>((resolve, reject) => {
    return fileEntry.file(resolve, reject);
  });
}

async function readDirectoryEntries(directoryEntry: FileSystemDirectoryEntry): Promise<FileSystemEntry[]> {
  return new Promise<FileSystemEntry[]>((resolve, reject) => {
    const subEntries: FileSystemEntry[] = [];
    const directoryReader = directoryEntry.createReader();

    const readEntriesLoop = () => {
      directoryReader.readEntries((results) => {
        if (results.length) {
          subEntries.push(...results);
          readEntriesLoop();
        } else {
          resolve(subEntries);
        }
      }, reject);
    };

    readEntriesLoop();
  });
}

function isUploadableFile(filetype: string, filesize: number, filename: string): boolean {
  return InspectionFileValidator.isValidInspectionFileType(filetype, filename)  && filesize > 0;
}
